<ng-container *ngIf="!!form && !!controlKey">
    <kal-icon *ngIf="form.get(controlKey).invalid" class="--error-notice">
        brightness_1
    </kal-icon>
</ng-container>
